import { appErrorCodes } from '@repo/constants'
import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { routeTree } from './routeTree.gen'
import './styles/globals.css'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if ('status' in error && typeof error.status === 'number') {
          return appErrorCodes.has(error.status) ? false : failureCount < 3
        }
        return failureCount < 3
      },
    },
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }

  interface StaticDataRouteOption {
    title?: string
    crumb?: string
  }
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    queryClient,
  },
  defaultPreloadStaleTime: 0,
})

export type RouterContext = {
  queryClient: QueryClient
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App router={router} queryClient={queryClient} />
  </StrictMode>,
)
